import { Journal } from "@/types";
import { sql } from "drizzle-orm";
import { MigrationConfig } from "drizzle-orm/migrator";
import { PgliteDatabase } from "drizzle-orm/pglite";

export async function hashMigration(message: string) {
    const msgBuffer = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);

    const hashArray = [...new Uint8Array(hashBuffer)];

    const hashHex = hashArray
        .map((byte) => byte.toString(16).padStart(2, '0'))
        .join('');

    return hashHex;
}

export async function migrate(
    db: PgliteDatabase,
    meta: { journal: Journal; callback: (tag: string) => Promise<string> },
    config?: Omit<MigrationConfig, 'migrationsFolder'>,
) {
    const migrationsTable = config === undefined ? "__drizzle_migrations" : config.migrationsTable ?? "__drizzle_migrations";
    const migrationsSchema = config === undefined ? "drizzle" : config.migrationsSchema ?? "drizzle";
    const migrationTableCreate = `
			CREATE TABLE IF NOT EXISTS ${migrationsSchema}.${migrationsTable} (
				id SERIAL PRIMARY KEY,
				hash text NOT NULL,
				created_at bigint
			)
		`;
    await db.execute(sql`CREATE SCHEMA IF NOT EXISTS ${sql.identifier(migrationsSchema)}`);
    await db.execute(migrationTableCreate);

    const dbMigrations = await db.execute(
        sql`select id, hash, created_at from ${sql.identifier(migrationsSchema)}.${sql.identifier(migrationsTable)} order by created_at desc limit 1`
    );
    const lastDbMigration = dbMigrations.rows[0];

    await db.transaction(async (tx) => {
        for await (const migration of meta.journal.entries) {
            if (!lastDbMigration || Number(lastDbMigration.created_at) < migration.when) {
                const sqlFile = await meta.callback(migration.tag)
                const result = sqlFile.split('--> statement-breakpoint').map((it) => {
                    return it;
                });
                for (const stmt of result) {
                    await tx.execute(stmt);
                }
                await tx.execute(
                    sql`insert into ${sql.identifier(migrationsSchema)}.${sql.identifier(migrationsTable)} ("hash", "created_at") values(${await hashMigration(sqlFile)}, ${migration.when})`
                );
            }
        }
    });
}

export async function getMigrations(db: PgliteDatabase) {
    const result = await db.execute(sql`SELECT * FROM drizzle.__drizzle_migrations`);
    console.log('get drizzle migrations', result);
    return result.rows;
}
export async function getLastMigration(db: PgliteDatabase) {
    const [res] = (await db.execute(sql`SELECT * FROM drizzle.__drizzle_migrations ORDER BY "created_at" DESC LIMIT 1`)).rows;
    return res;
}